export enum Membership {
  Member = 'member',
  Pending = 'pending',
}
